import { render, staticRenderFns } from "./NotFoundComponent.vue?vue&type=template&id=60b6ef24&scoped=true&"
import script from "./NotFoundComponent.vue?vue&type=script&lang=js&"
export * from "./NotFoundComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b6ef24",
  null
  
)

export default component.exports